import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserCircle, Wrench } from "@phosphor-icons/react";

const Register = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", role: "cliente" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/register", form);
      login(res.data.token, res.data.user);
      toast.success("Account creato!");
      navigate(form.role === "professionista" ? "/pro/onboarding" : "/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore registrazione");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-10">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md bg-card border border-border rounded-2xl p-7 shadow-sm">
        <h1 className="font-heading text-2xl font-bold">Crea il tuo account</h1>
        <p className="text-muted-foreground text-sm mt-1">Unisciti a NEXA come cliente o professionista.</p>

        <div className="grid grid-cols-2 gap-3 mt-5">
          {[["cliente", "Cliente", UserCircle], ["professionista", "Professionista", Wrench]].map(([val, lbl, Icon]) => (
            <button key={val} type="button" data-testid={`role-${val}`} onClick={() => set("role", val)}
              className={`flex flex-col items-center gap-2 p-4 rounded-xl border transition-colors ${form.role === val ? "border-primary bg-accent" : "border-border hover:border-primary/40"}`}>
              <Icon size={26} weight="duotone" className={form.role === val ? "text-primary" : ""} />
              <span className="text-sm font-medium">{lbl}</span>
            </button>
          ))}
        </div>

        <form onSubmit={submit} className="mt-5 space-y-4">
          <div><Label>Nome {form.role === "professionista" ? "attività" : "completo"}</Label>
            <Input value={form.name} onChange={(e) => set("name", e.target.value)} required data-testid="reg-name" className="mt-1.5" /></div>
          <div><Label>Email</Label>
            <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required data-testid="reg-email" className="mt-1.5" /></div>
          <div><Label>Telefono</Label>
            <Input value={form.phone} onChange={(e) => set("phone", e.target.value)} data-testid="reg-phone" className="mt-1.5" /></div>
          <div><Label>Password</Label>
            <Input type="password" value={form.password} onChange={(e) => set("password", e.target.value)} required data-testid="reg-password" className="mt-1.5" /></div>
          <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="reg-submit">
            {loading ? "Creazione…" : "Registrati"}
          </Button>
        </form>
        <p className="text-sm text-center text-muted-foreground mt-6">
          Hai già un account? <Link to="/login" className="text-primary font-medium" data-testid="to-login">Accedi</Link>
        </p>
      </motion.div>
    </div>
  );
};

export default Register;
